import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    width: '100%',
    paddingHorizontal: 17,
    overflow: 'hidden',
  },
  lineBottom: theme => ({
    height: 1,
    marginBottom: 7,
    backgroundColor: theme.colors.borderColorFour,
    marginHorizontal: -16.6,
  }),
  tick: {
    width: 25,
    height: 25,
  },
  price: {
    marginBottom: 19,
    marginTop: 5,
  },
  currentBillHeader: withBillDate => ({
    justifyContent: withBillDate ? 'space-between' : 'flex-end',
    flexDirection: 'row',
  }),
  year: theme => ({
    fontSize: 16,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  priceText: theme => ({
    fontSize: 42,
    fontFamily: Fonts.type.VodafoneLt,
    top: Platform.OS === 'android' ? 4 : 0,
    color: theme.colors.textColorThree,
  }),
  currency: theme => ({
    fontSize: 28,
    color: theme.colors.textColorThree,
    fontFamily: Fonts.type.VodafoneLt,
  }),
  month: theme => ({
    fontSize: 24,
    fontFamily: Fonts.type.VodafoneLt,
    lineHeight: 31.5,
    marginTop: 5,
    color: theme.colors.textColorThree,
  }),
  extraChargesContainer: {
    paddingVertical: 10,
    paddingBottom: 5,
  },
  extraChargesLabel: {
    marginBottom: 15,
  },
  extraChargeItem: {
    marginVertical: 4,
  },
  negativeBill: theme => ({
    color: theme.colors.textColorThree,
  }),
  negativeBalanceContainer: {
    alignItems: 'center',
  },
  negativeBalanceText: theme => ({
    fontSize: 16.6,
    marginRight: 7,
    color: theme.colors.showMoreColor,
  }),
  icon: {
    marginRight: -2,
  },
  errorBackgroundStyle: {
    backgroundColor: Colors.transparent,
    height: 340,
    width: 340,
  },
  errorIconStyle: {
    marginTop: 118.6,
    width: 40,
    height: 40,
  },
  errorTextStyle: {
    marginBottom: 18.4,
  },
  errorTryButtonContainerStyle: {
    marginTop: 0,
  },
  extraChargesText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  extraRoamingText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorThree,
  }),
  getNegativeBill: theme => ({
    color: theme.colors.textColorThree,
  }),
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingVertical: 15,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
    marginVertical: 16
  }),
});
